module.exports = __webpack_public_path__ + "static/img/bj.1efbd95.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/HomeSignIn/bj.png
// module id = 488
// module chunks = 0